import {
  type FactorySansProvider,
  InjectionToken,
  type Signal,
} from '@angular/core';

export type FormErrors = Record<
  string,
  ((error: any) => string | Signal<string>) | string | Signal<string>
>;

export interface FormErrorsProvider extends FactorySansProvider {
  useFactory: (...args: any[]) => FormErrors;
}

export const FORM_ERRORS = new InjectionToken<FormErrors>('tvd.form-errors', {
  providedIn: 'root',
  factory: () => ({}),
});

export type FormErrorsConfig = {
  errors?: FormErrorsProvider;
};

export const FORM_ERRORS_CONFIG = new InjectionToken<FormErrorsConfig>(
  'tvd.form-errors-config',
);

export const provideFormErrors = (config: FormErrorsConfig) => {
  return [
    { provide: FORM_ERRORS_CONFIG, useValue: config },
    { provide: FORM_ERRORS, ...config.errors },
  ];
};
